import React, { createContext, useContext, useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';
import { useAuth } from './useAuth';

const SocketContext = createContext(null);

const socketBase =
  typeof window !== 'undefined' && window.location?.origin
    ? window.location.origin
    : process.env.REACT_APP_API_URL;

const normalizarMensagem = (msg) => ({
  ...msg,
  atendenteId: msg.atendenteId || msg.atendente_id,
  ts: msg.ts || msg.sent_at,
});

export function SocketProvider({ children }) {
  const { token } = useAuth();
  const socketRef = useRef(null);
  const [connected, setConnected] = useState(false);
  const [alertas, setAlertas] = useState([]);
  const [mensagensLive, setMensagensLive] = useState([]);
  const [instancias, setInstancias] = useState({});

  useEffect(() => {
    if (!token) return;

    const socket = io(socketBase, {
      auth: { token },
      transports: ['websocket', 'polling']
    });

    socket.on('connect', () => setConnected(true));
    socket.on('disconnect', () => setConnected(false));

    socket.on('snapshot', (data) => {
      setAlertas(data.alertasPendentes || []);
      setMensagensLive((data.mensagensRecentes || []).map(normalizarMensagem));
    });

    socket.on('nova_mensagem', (msg) => {
      setMensagensLive(prev => [normalizarMensagem(msg), ...prev].slice(0, 100));
    });

    socket.on('novo_alerta', (alerta) => {
      setAlertas(prev => [alerta, ...prev]);
    });

    socket.on('alerta_resolvido', ({ alertaId }) => {
      setAlertas(prev => prev.filter(a => a.id !== alertaId));
    });

    socket.on('status_instancia', ({ instance, status }) => {
      setInstancias(prev => ({ ...prev, [instance]: status }));
    });

    socketRef.current = socket;
    return () => { socket.disconnect(); };
  }, [token]);

  const resolverAlerta = (alertaId) => {
    socketRef.current?.emit('resolver_alerta', alertaId);
  };

  const monitorarAtendente = (id) => {
    socketRef.current?.emit('monitorar_atendente', id);
  };

  return (
    <SocketContext.Provider value={{
      socket: socketRef.current,
      connected,
      alertas,
      mensagensLive,
      instancias,
      resolverAlerta,
      monitorarAtendente
    }}>
      {children}
    </SocketContext.Provider>
  );
}

export function useSocket() {
  return useContext(SocketContext);
}
